const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

export type Benefit = {
  id: string
  icon: string
  text: string
}

export const benefits: Benefit[] = [
  {
    id: 'integridade',
    icon: `${IMAGES_PATH}/benefits/integridade.svg`,
    text: 'Fortalece a cultura de integridade'
  },
  {
    id: 'confianca',
    icon: `${IMAGES_PATH}/benefits/confianca.svg`,
    text: 'Aumenta a confiança nas relações com parceiros, fornecedores e clientes'
  },
  {
    id: 'governanca',
    icon: `${IMAGES_PATH}/benefits/governanca.svg`,
    text: 'Melhora os padrões de governança'
  },
  {
    id: 'fraude',
    icon: `${IMAGES_PATH}/benefits/fraude.svg`,
    text: 'Previne e combate à fraude, lavagem de dinheiro e a corrupção'
  },
  {
    id: 'sustentavel',
    icon: `${IMAGES_PATH}/benefits/sustentavel.svg`,
    text: 'Contribui para um mundo de negócios mais ético e sustentável'
  }
]
